<div
    id="item-editor-item-information-container"
    class="item-information-container"
    [class.no-item-description]="!showItemDescription()">
    <div class="item-name-wrapper">
        <span class="item-name">{{name()}}</span>
        @if(loyaltyPoints()){
            <span class="header-loyalty-points">{{ 'modals.item_editor.loyalty_points.badge' | transloco: {points: loyaltyPoints()} }}</span>
        }
    </div>
    @if(hasCalories()) {
        <p class="calories-text">{{hasCalories()}}</p>
    }
    @if(noticePeriodNoSize()){
        <span class="notice-period">{{noticePeriodNoSize()}}</span>
    }

    @if(details){
        <cwo-expandable-component #expandable class="details-container" [ariaControlsName]="'expandableTitle'" (isExpanded)="handleDetailsToggle($event)">
            <ng-template #heading>
                <div class="header" [style]="detailsExpanded ? 'padding-bottom: 24px; transition: all 0.2s' : 'padding-bottom: 0px; transition: all 0.2ss'">
                    <span class="title">{{'modals.special_item_editor.details.'+(detailsExpanded ? 'hide' : 'view') | transloco}}</span>
                <cwo-icon class="icon" [name]="iconName.arrow"
                    [ngStyle]="{ transform: detailsExpanded ? 'rotate(-180deg)' : 'rotate(0deg)' }" />
                </div>
            </ng-template>
            <ng-template #content>
                <ng-container [ngTemplateOutlet]="details"></ng-container>
            </ng-template>
        </cwo-expandable-component>
    }

    <div>
        @if(showItemNameOnSpecialSingeStep()){
            <span class="secondary-item-name">{{this.orderedItem()?.webName ?? this.orderedItem()?.item}}</span>
        }
        @if(showItemDescription() || surcharge() || orderableItem()?.sizePrices?.length === 1 && orderedItem()?.size !== 'Size' || selectedIngredients().length > 0) {
            <div class="description-size-wrapper">        
                @if(showItemDescription()) {
                    <span class="item-description">{{orderableItem()?.description}}</span>
                }
                @if(surcharge()){
                    <span class="surcharge">{{'modals.special_item_editor.special_item.additional_charge' | transloco: {amount: (surcharge() | currency: 'USD')} }}</span>
                }
                @if(printableIngredients().length > 0) {
                    <div class="selected-ingredients-container">
                        @if(showItemDescription()) {
                            <span class="selections-label">{{'modals.item_editor.item_editor_header.selections' | transloco}}</span>
                        }
                        @for (ingredient of printableIngredients(); track $index; let last = $last) {
                            <span class="selected-ingredient" [ngClass]="{'removed': ingredient.removed, 'bold': !ingredient.default || ingredient.removed}">{{getSelectedIngredientDescription(ingredient)}}</span>
                            @if (!last) {
                                <span class="separator">, </span>
                            }
                        }
                    </div>
                }
                @if(orderableItem()?.sizePrices?.length === 1 && orderedItem()?.size !== 'Size' && size()) {
                    <span class="size">{{size()}}</span>
                }
            </div>
        }
    </div>
    
    
</div>
